import { useContext, useEffect } from "react"

import { Stack, Text } from "@chakra-ui/react"
import { ApplicationData } from "types"

import { H1 } from "components/common"
import { LoadingScreen } from "components/LoadingScreen"

import { ClientContext } from "context/ClientContext"
import { UserContext } from "context/UserContext"

interface ConfirmationPageProps {
  applicationData: ApplicationData
}

const ConfirmationPage = ({ applicationData }: ConfirmationPageProps) => {
  const { user } = useContext(UserContext)
  const { client } = useContext(ClientContext)

  const submissionRedirectUrl = applicationData?.meta?.submissionRedirectUrl

  useEffect(() => {
    if (submissionRedirectUrl) {
      let redirectUrl = submissionRedirectUrl

      if (user?.userId && client?.theme === "creighton") {
        redirectUrl = `${redirectUrl}?uid=${user.userId}`
      }

      window.location.replace(redirectUrl)
    }
  }, [submissionRedirectUrl])

  if (!applicationData || submissionRedirectUrl) {
    return <LoadingScreen show={true} />
  }

  return (
    <Stack paddingY={{ base: 4, md: 8, lg: 12 }} spacing={{ base: 4, md: 6 }}>
      <H1>We've received your {applicationData.meta.name} application!</H1>
      <Text>
        Thank you! We'll be in contact soon to collect a few remaining items to
        complete your file.
      </Text>
    </Stack>
  )
}

export default ConfirmationPage
